import { returnsDefaultWeightByCountrySchema } from "@redotech/redo-fulfillment-rate-table-common/rate-table";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { countryRateTableEntriesOutput } from "./country-rate-table-entries";

export const saveDefaultCountryRateTable = {
  name: "saveDefaultCountryRateTable" as const,
  input: z.object({
    rateTable: returnsDefaultWeightByCountrySchema,
    /** Absent = create a new card; present = update that card in place. */
    id: zExt.objectId().optional(),
  }),
  output: countryRateTableEntriesOutput,
};
